module.exports = __webpack_public_path__ + "static/get-b0912432b4373245ca520c3813b1c680.png";